import React from 'react';
import {PublisherSimilarBookModel} from "../../../models/publisher/publisher-similar-book.model";
import {Grid} from "@mui/material";
import styled from "styled-components";
import {Colors} from "../../../theme/colors";
import {CustomArrowRightIcon} from "../../ui-base/icons/custom-arrow-right-icon";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {SmallBookCover} from "../../shared/small-book-cover";

export const SimilarBookViewList: React.FC<{book: PublisherSimilarBookModel, exampleBook?: boolean}> = ({book, exampleBook = false}) => {
    const { t } = useTranslation(['publisher', 'common']);

    return (
      <Grid item sm={12} md={6} lg={3}>
          <StyledContainer item container direction={'column'}>
              {(!book.cover || !book.cover.file) &&
                  <StyledImageContainer item>
                      <SmallBookCover
                          title={book?.title}
                          description={book?.description}
                          author={book.authors}
                      />
                  </StyledImageContainer>
              }
              {book.cover?.file &&
              <StyledImageContainer item>
                  <StyledImg src={book.cover.file}/>
              </StyledImageContainer>
              }

              <Grid item container direction={'column'} spacing={1}>
                  <Grid item>
                      <StyledP>{t('bookList.isbn')}: {book.isbn}</StyledP>
                  </Grid>

                  <Grid item>
                      <StyledP>{t('bookList.authors')}: {book.authors}</StyledP>
                  </Grid>
              </Grid>

              <StyledActionContainer item container justifyContent={"space-between"}>
                  <Grid item>
                      {!exampleBook &&
                      <StyledProfileLink to={'/publisher/similar-books/edit/' + book.id}>
                          {t('common:edit')}
                      </StyledProfileLink>
                      }
                  </Grid>

                  {(book.search_similar_books || exampleBook) &&
                  <Grid item>
                      <StyledProfileLink to={((!exampleBook) ? '/publisher/similar-books/details/': '/publisher/similar-books/example/') + book.id}>
                          {t('bookList.checkSimilar')}
                          <CustomArrowRightIcon style={{width: '12px', height: '10px', marginLeft: '5px'}}/>
                      </StyledProfileLink>
                  </Grid>
                  }

                  {!book.search_similar_books && !exampleBook &&
                  <Grid item>
                      <StyledAnalyzingP>{t('bookList.analizing')}</StyledAnalyzingP>
                  </Grid>
                  }
              </StyledActionContainer>
          </StyledContainer>
      </Grid>
    );
}

const StyledContainer = styled(Grid)`
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #E0E0E0;
  margin-top: 100px !important;
  padding: 0 20px 20px;
`;

const StyledImageContainer = styled(Grid)`
  margin-top: -80px !important;
  position: relative;
`;

const StyledImg = styled('img')`
  width: 175px;
  -webkit-box-shadow: -11px 0px 50px -34px ${Colors.neutral30};
  -moz-box-shadow: -11px 0px 50px -34px ${Colors.neutral30};
  box-shadow: -11px 0px 50px -34px ${Colors.neutral30};
`;

const StyledP = styled('p')`
  font-size: 0.9rem;
  color: ${Colors.grayText};
  font-weight: 400;
`;

const StyledProfileLink = styled(Link)`
  color: ${Colors.lightViolet};
  font-weight: 500;
`;

const StyledActionContainer = styled(Grid)`
  margin-top: 10px !important;
`;

const StyledAnalyzingP = styled('p')`
  color: ${Colors.lightViolet};
  font-weight: 500;
  font-style: italic;
`;
